import axios from "axios";


export default {

    async getConfiguracio(): Promise<any> {
        return axios
            .get(import.meta.env.VITE_API_URL + `/apiV2/configuracio?recurs=ModCaravaning`)
            .then(async (response: { data: any }) => {
                return response.data;
            })
            .catch( (error: any) => Promise.reject(error));
    },
}